import Brand1 from "../../assets/images/brands/brand-1.png";
import Brand2 from "../../assets/images/brands/brand-2.png";
import Brand3 from "../../assets/images/brands/brand-3.png";
import Brand4 from "../../assets/images/brands/brand-4.png";
import Brand5 from "../../assets/images/brands/brand-5.png";
import Brand6 from "../../assets/images/brands/brand-6.png";
import Brand7 from "../../assets/images/brands/brand-7.png";
import Brand8 from "../../assets/images/brands/brand-8.png";
import Brand9 from "../../assets/images/brands/brand-9.png";
import Brand10 from "../../assets/images/brands/brand-10.png";
import Brand11 from "../../assets/images/brands/brand-11.png";
import Brand12 from "../../assets/images/brands/brand-12.png";
import Brand13 from "../../assets/images/brands/brand-13.png";
import Brand14 from "../../assets/images/brands/brand-14.png";
import Brand15 from "../../assets/images/brands/brand-15.png";
import Brand16 from "../../assets/images/brands/brand-16.png";
import Brand17 from "../../assets/images/brands/brand-17.png";
import Brand18 from "../../assets/images/brands/brand-18.png";

const brands = [
	{
		id: 1,
		img: Brand1,
	},
	{
		id: 2,
		img: Brand2,
	},
	{
		id: 3,
		img: Brand3,
	},
	{
		id: 4,
		img: Brand4,
	},
	{
		id: 5,
		img: Brand5,
	},
	{
		id: 6,
		img: Brand6,
	},
	{
		id: 7,
		img: Brand7,
	},
	{
		id: 8,
		img: Brand8,
	},
	{
		id: 9,
		img: Brand9,
	},
	{
		id: 10,
		img: Brand10,
	},
	{
		id: 11,
		img: Brand11,
	},
	{
		id: 12,
		img: Brand12,
	},
	{
		id: 13,
		img: Brand13,
	},
	{
		id: 14,
		img: Brand14,
	},
	{
		id: 15,
		img: Brand15,
	},
	{
		id: 16,
		img: Brand16,
	},
	{
		id: 17,
		img: Brand17,
	},
	{
		id: 18,
		img: Brand18,
	},
];

export default brands;
